import React from 'react';
import { Typography, COLORS } from 'pvs-design-system';
import { Box } from '@mui/material';
import Folder from '@mui/icons-material/Folder';

interface LibraryEmptyStateProps {
  /** When true the message is styled as an error (red) instead of muted gray. */
  isError?: boolean;
  message: string;
}

/**
 * Centered folder icon + message used for the empty / error state of a
 * folder's contents (browse and home views).
 */
const LibraryEmptyState: React.FC<LibraryEmptyStateProps> = ({ isError = false, message }) => (
  <Box sx={{ py: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
    <Folder sx={{ fontSize: 40, color: COLORS.gray[200] }} />
    <Typography variant="p-sm" style={{ color: isError ? COLORS.red[800] : COLORS.gray[400] }}>
      {message}
    </Typography>
  </Box>
);

export default LibraryEmptyState;
